import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HinhThucGuiService } from './hinh-thuc-gui.service';
import { Router } from '@angular/router';
import { IHinhThucGui } from './hinh-thuc-gui';
import { AuthService } from '../services/auth.service';

declare var jQuery: any;
@Component({
    selector: 'vnpt-chuc-vu',
    templateUrl: './hinh-thuc-gui.component.html',
    providers: [HinhThucGuiService]
})
export class HinhThucGuiComponent implements OnInit {
    @ViewChild("divTen") divTen: ElementRef;
    title: string = "Hình thức gửi"
    listItem: IHinhThucGui[] = [];

    detailItem: IHinhThucGui;
    saveStatusMessage: string = "";
    saveStatus: boolean = true;

    changeAddUpdate: string = "Thêm";

    idTinhThanh: number = this.auth.user.IdTinhThanh;

    paging: number = 1;
    totalCount: number = 0;
    totalPages: number = 1;
    total: number;
    page: number;
    keyword: string = '';
    size: number;

    constructor(private service: HinhThucGuiService,
        private router: Router,
        private titleService: Title,
        private auth: AuthService) {
    }

    ngOnInit() {
        this.titleService.setTitle('Quản lý ' + this.title);
        this.GetListFromPagination(this.paging);
        this.keyword = "";
        //this.GetList();
        this.Reset();
    }

    Reset() {
        this.detailItem = {
            Id: null,
            Ten: '',
            MoTa: '',
            IdTinhThanh: this.idTinhThanh
        }
        this.changeAddUpdate = "Thêm";
        this.divTen.nativeElement.hidden = true;
    }

    KeyUpTen() {
        this.divTen.nativeElement.hidden = true;
    }

    // Lấy danh sách từ Stored Procedure phân trang
    GetListFromPagination(paging: number) {
        let pageSize = 8;
        this.service.GetListFromPagination(this.idTinhThanh, paging, this.keyword, pageSize)
            .subscribe(
            (data) => {
                this.listItem = data;
                if (this.listItem.length !== 0) {
                    // tổng records trong list cấp đơn vị
                    this.paging = paging;
                    this.totalCount = (data[0]).TotalRows;
                    this.totalPages = Math.ceil(this.totalCount / pageSize); // tính tổng số trang cần phân dựa vào tổng records
                } else {
                    if (paging > 1) {
                        this.GetListFromPagination(paging - 1);
                    } else {
                        this.totalPages = 0;
                    }
                }

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }

    createRange(number) {
        let items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }

    valuechange(newValue) {
        this.keyword = newValue;
        this.GetListFromPagination(1);
    }

    // GetList
    GetList() {
        this.service.GetList(this.idTinhThanh)
            .subscribe(
            (data) => {
                this.listItem = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });

    }

    GetItem(item: IHinhThucGui) {
        this.detailItem.Id = item.Id;
        this.detailItem.MoTa = item.MoTa;
        this.detailItem.Ten = item.Ten;
        this.changeAddUpdate = "Sửa";
        this.divTen.nativeElement.hidden = true;
    }

    Save(item?: IHinhThucGui) {
        if (this.detailItem.Ten) {
            this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
            jQuery("#loader").modal();
            this.service.Save(item).subscribe(
                (resp) => {
                    if (resp.Success) {
                        jQuery("#myModalAdd").modal('hide');
                        this.GetList();
                        this.saveStatusMessage = this.changeAddUpdate + " " + item.Ten + " thành công!";
                        this.saveStatus = true;
                        jQuery("#loader").modal();
                        this.Reset();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi " + this.changeAddUpdate + " " + item.Ten + "! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        } else {
            this.divTen.nativeElement.hidden = false;
        }
    }

    Delete(item: IHinhThucGui) {
        this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
        jQuery("#loader").modal();
        this.service.Delete(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    this.GetList();
                    this.saveStatusMessage = "Xóa " + item.Ten + " thành công!";
                    this.saveStatus = true;
                    jQuery("#loader").modal();
                }
                else {
                    this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )
        this.Reset();
    }

}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/hinh-thuc-gui/hinh-thuc-gui.component.ts